import type { SVGProps } from 'react';

const SvgFitHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 19h-4.09l2.79-2.79a.996.996 0 1 0-1.41-1.41L13 16.09V7.91l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L12.92 5h4.09c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h4.09L8.3 7.79A.996.996 0 1 0 9.71 9.2L11 7.91v8.17l-1.29-1.29A.996.996 0 1 0 8.3 16.2l2.79 2.79H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgFitHeight;
